import React, { useState, useRef } from "react";
import { useHover } from "react-aria";
import { Link } from "gatsby";
import "./dropdownlink.scss";

interface idropdownProps {
  linkItem: any;
}

const Dropdownlink: React.FC<idropdownProps> = (props) => {
  const { hoverProps, isHovered } = useHover(props as any);

  return (
    <>
      <li {...hoverProps}>
        <Link
          activeClassName="active"
          to={props.linkItem.url}
          style={{ position: "relative" }}
          className="flex gap-2 items-center"
        >
          {props.linkItem.text}
        </Link>
        <div className={`dropdown-menu ${isHovered && "open"}`}>
          <ul className="dropdown-list" {...hoverProps}>
            {props.linkItem?.dropdown?.map(
              (dropdownItem: any, dropdownidx: number) => (
                <li key={dropdownidx}>
                  <Link activeClassName="active" to={dropdownItem.urlDropdown}>
                    {dropdownItem.textDropdown}
                  </Link>
                </li>
              )
            )}
          </ul>
        </div>
      </li>
    </>
  );
};

export default Dropdownlink;
